import React from 'react';
import WeatherCard from './WeatherCard';
import './WeatherDisplay.css';

/**
 * WeatherDisplay Component
 * Demonstrates: Props usage, conditional rendering, component composition
 * @param {Object} weatherData - Weather data to display
 * @param {boolean} loading - Loading state
 * @param {string} error - Error message if any
 */
const WeatherDisplay = ({ weatherData, loading, error }) => {
  if (loading) {
    return (
      <div className="weather-display">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Fetching weather data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="weather-display">
        <div className="error-container">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="error-icon">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <h3 className="error-title">Oops! Something went wrong</h3>
          <p className="error-message">{error}</p>
          <p className="error-hint">Please check the city name and try again.</p>
        </div>
      </div>
    );
  }

  if (!weatherData) {
    return (
      <div className="weather-display">
        <div className="welcome-container">
          <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="welcome-icon">
            <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
          </svg>
          <h2 className="welcome-title">Welcome to Weather App</h2>
          <p className="welcome-message">
            Search for a city to get started and view current weather conditions.
          </p>
          <div className="quick-cities">
            <p className="quick-cities-label">Try searching for:</p>
            <div className="city-suggestions">
              <span className="city-tag">Toronto</span>
              <span className="city-tag">London</span>
              <span className="city-tag">Tokyo</span>
              <span className="city-tag">Paris</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="weather-display">
      <WeatherCard weatherData={weatherData} />
    </div>
  );
};

export default WeatherDisplay;
